import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

import { COMN_SF_LPCO_SRCH, COMN_SG_LPCO_LIST_HEAD, COMN_SG_LPCO_LIST_BODY } from "@/tz/go/egaz/osci/lpco/cfgn/comn";

/*
 *  Responsibility Settings
 * !== Responsibility Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/cfgn/chpn`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/chpn`,
    ogaComnApi: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/comn`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0203025s: `${BASE.path}/osci0203025s`, // Register Department and Officer in Charge   !== 담당부서 및 담당자 등록  ==!
    osci0203026q: `${BASE.path}/osci0203026q`, // Register Department and Officer in Charge List  !== 담당부서 및 담당자 구성 목록 조회  ==!
    osci0203027s: `${BASE.path}/osci0203027s`, // Register Department and Officer in Charge Detail  !== 담당부서 및 담당자 구성 상세 조회  ==!
    osci0203028s: `${BASE.path}/osci0203028s`, // Department and Officer in Charge Modification  !== 담당부서 및 담당자 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    /* Responsibility list inquiry !== Responsibility 목록 조회 ==! */
    getLpcoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    /* LPCO detailed inquiry !== Responsibility 상세 조회 ==! */
    getAppDtl: (appFmId: any) => {
        return api.get(`${BASE.api}/${appFmId}`);
    },
    /* Register LPCO information !== Responsibility 등록 ==! */
    createAppChpn: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    saveAppChpn: (data: any) => {
        return api.put(`${BASE.api}/${data.appFmId}`, {
            ...data,
        });
    },

    getAppDtlByAppCdNo: (appCdNo: any) => {
        console.log("getAppDtlByAppCdNo ", appCdNo);
        return api.get(`${BASE.api}/app-cd-no/${appCdNo}`);
    },
    getOrgDeptUserList: (orgCd: any, deptCd: any) => {
        return api.get(`${BASE.ogaComnApi}/dept_usr/${orgCd}-${deptCd}`);
    },
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */
/**
 * Component Setting > Register Responsibilitys
 */
// Responsibility Schema !== Responsibility ==!
export const SF_LPCO_INFO_R: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "text",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
    },
};

export const SF_LPCO_INFO_U: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            required: true,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            edit: false,
            controlSize: 10,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

/**
 * Component Setting > LPCO LIST
 */
// Responsibility Search Schema !== Responsibility Search  ==!
export const SF_LPCO_SRCH: TFormSchema = {
    id: "form_LpcoSrch",
    schema: { ...COMN_SF_LPCO_SRCH },
};

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_LIST_R: TGridSchema = {
    id: "grid_lpcoList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        ...COMN_SG_LPCO_LIST_HEAD,
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 80 }] } /* Use Yn */,
        { cells: [{ header: "L_NUM_CHPN", binding: "cnt", width: "15%" }] } /* Number of Assignment */,
    ],
    body: [
        ...COMN_SG_LPCO_LIST_BODY,
        {
            cells: [
                {
                    binding: "useYn",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    type: "select",
                    viewType: "value",
                },
            ],
        },
        { cells: [{ binding: "cnt", type: "number", align: "center" }] },
    ],
};

/**
 * Responsibility DETAIL
 */

// Responsibility Schema !== Responsibility ==!
export const SG_ORG_DEPT_USR_LIST_U: TGridSchema = {
    id: "grid_deptUsrUList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 210,
        sort: true,
    },
    head: [
        // { cells: [{ header: "Department Name", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_USR_ID", binding: "usrId", width: "*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "asnmtOfcrTpCd", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "deptNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "usrId",
                    align: "left",
                    type: "text",
                    edit: false,
                },
            ],
        },
        { cells: [{ binding: "usrNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    edit: true,
                    area: "comnCd",
                    comnCd: "OSC0119",
                    required: true,
                    excludes: ["MA", "DT", "LC", "CC"], // 2026-04-20 Roy Change to show 'AC' !== AC는 표시하도록 변경 ==!
                },
            ],
        },
    ],
};

export const SG_SETT_DEPT_LIST_R: TGridSchema = {
    id: "grid_deptUList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        // { cells: [{ header: "Department Name", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_USR_ID", binding: "usrId", width: "*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "asnmtOfcrTpCd", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "deptNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "usrId",
                    align: "left",
                    type: "text",
                    edit: false,
                },
            ],
        },
        { cells: [{ binding: "usrNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0119",
                    edit: false,
                    excludes: ["MA", "DT", "LC", "CC"], // 2026-04-20 Roy Change to show 'AC' !== AC는 표시하도록 변경 ==!
                },
            ],
        },
    ],
};

export const SG_SETT_OFCR_LIST_U: TGridSchema = {
    id: "grid_ofcrUList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        sort: false,
        height: 350,
    },
    head: [
        // { cells: [{ header: "Department Name", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_USR_ID", binding: "usrId", width: "*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "asnmtOfcrTpCd", width: "*" }] },
        { cells: [{ header: "L_AUTH", binding: "authYn", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "deptNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "usrId",
                    align: "left",
                    type: "text",
                    edit: false,
                },
            ],
        },
        { cells: [{ binding: "usrNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    edit: false,
                    area: "comnCd",
                    comnCd: "OSC0119",
                    excludes: ["MA", "DT", "LC", "CC"], // 2026-04-20 Roy Change to show 'AC' !== AC는 표시하도록 변경 ==!
                },
            ],
        },
        { cells: [{ binding: "authYn", align: "center", type: "text", edit: false }] },
    ],
};

export const SG_SETT_OFCR_LIST_R: TGridSchema = {
    id: "grid_ofcrRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        sort: true,
        height: 350,
    },
    head: [
        // { cells: [{ header: "Department Name", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_USR_ID", binding: "usrId", width: "*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "asnmtOfcrTpCd", width: "*" }] },
        { cells: [{ header: "L_AUTH", binding: "authYn", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "deptNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "usrId",
                    align: "left",
                    type: "text",
                    edit: false,
                },
            ],
        },
        { cells: [{ binding: "usrNm", align: "left", type: "text", edit: false }] },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    edit: false,
                    area: "comnCd",
                    comnCd: "OSC0119",
                    excludes: ["MA", "DT", "LC", "CC"], // 2026-04-20 Roy Change to show 'AC' !== AC는 표시하도록 변경 ==!
                },
            ],
        },
        { cells: [{ binding: "authYn", align: "center", type: "text", edit: false }] },
    ],
};
